import type { ChecklistFilter, Room, RoomDashboardEntry } from '@dataroom/shared';

/** The room's checklist, filtered (`?filter=`, read by RoomChecklistPage). */
export function checklistHref(roomId: string, filter: ChecklistFilter = 'missing'): string {
  return `/rooms/${roomId}/checklist?filter=${filter}`;
}

/** Latest-first instant compare; a missing instant sorts last. */
function byRecent(a: string | null, b: string | null): number {
  if (a === b) return 0;
  if (a === null) return 1;
  if (b === null) return -1;
  return Date.parse(b) - Date.parse(a);
}

/**
 * The active rooms in dashboard order. Rooms with figures first, by MOST ITEMS
 * STILL MISSING — the intermediary's standing job on this page is chasing the
 * seller for documents, so the deal with the most outstanding requests leads —
 * then by the most recent buyer activity, then by name. A room without figures
 * (one a colleague administers: the tenant list names it, but its figures are
 * not the caller's to see) keeps the list's own order after them. A plain sort
 * on facts — no score. Pure.
 */
export function sortActiveRooms(
  rooms: readonly Room[],
  figures: ReadonlyMap<string, RoomDashboardEntry>,
): Room[] {
  const withFigures = rooms.filter((r) => figures.has(r.id));
  const without = rooms.filter((r) => !figures.has(r.id));
  withFigures.sort((a, b) => {
    const fa = figures.get(a.id)!;
    const fb = figures.get(b.id)!;
    return (
      fb.checklist.missing - fa.checklist.missing ||
      byRecent(fa.lastBuyerActivityAt, fb.lastBuyerActivityAt) ||
      a.name.localeCompare(b.name)
    );
  });
  return [...withFigures, ...without];
}
